import React, { Suspense, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { BrowserRouter } from "react-router-dom";

import { Route, Routes } from "react-router";
import Dashboard from "pages/dashboard";

import GuestRoute from "helpers/authentication/guestRoute";
import AuthRoute from "helpers/authentication/authRoute";

import Layout from "./components/Layout/layout";
import NotFound from "views/NotFound";
import Login from "views/login";
import Logout from "views/Logout";
import Register from "views/Register";

import { getCurrentUser } from "store/actions";
import Loader from "./components/shared/loader";

//applications

import Applications from "pages/applications/main/index";
import AddApplication from "views/Applications/Add";
import EditApplication from "views/Applications/Edit";

//applications revisions
import Reviews from "views/Applications/Reviews";

//applications customPlans

import CustomPlans from "views/Applications/CustomPlans";
import AddCustomPlan from "views/Applications/CustomPlans/Add";
import EditCustomPlan from "views/Applications/CustomPlans/Edit";

//themes

import Themes from "views/Themes";
import AddTheme from "views/Themes/Add";
import EditTheme from "views/Themes/Edit";

//Subscriptions

import Subscriptions from "pages/subscriptions";

//DemoStores

import DemoStores from "pages/demo-stores/main";
import AddDemoStore from "views/DemoStores/Add";
import EditDemoStore from "views/DemoStores/Edit";

//Employees

import Employees from "views/Employees";
import AddEmployee from "views/Employees/Add";
import EditEmployee from "views/Employees/Edit";

//Payments

import Payments from "views/Payments";

import Settings from "views/Settings";

import TaxNumber from "views/TaxNumber";

//Coupons

import Coupons from "views/Coupons";
import AddCoupon from "views/Coupons/Add";
import EditCoupon from "views/Coupons/Edit";

//paymentMethod

import PaymentMethods from "views/PaymentMethods";
import AddPaymentMethod from "views/PaymentMethods/Add";
import EditPaymentMethod from "views/PaymentMethods/Edit";

//webhooks

import Webhooks from "views/Webhooks";
import EditWebhook from "views/Webhooks/Edit";

import ViewEditProfile from "views/Profile";
import IdentityVerification from "views/IdentityVerification";
import { REACT_APP_URL } from "config";

const App = () => {
    const dispatch = useDispatch();
    const token = localStorage.getItem("token");

    //selectors
    const { isLoggedIn } = useSelector((state) => state?.authentication);
    const { settings } = useSelector((state) => state.settings);
    const logo = settings?.appLogo
        ? REACT_APP_URL + settings?.appLogo
        : "https://ejjadh.sa/_next/image?url=https%3A%2F%2Fbasewebsite.ejjadh.info%2F%2Fstorage%2Fuploads%2F0dVcv2-1657016906.png&w=128&q=75";

    useEffect(() => {
        // dispatch(getAllSettings());
    }, [dispatch]);

    useEffect(() => {
        if (token) dispatch(getCurrentUser());
    }, [token, dispatch]);

    const RenderApp = () => {
        return (
            <Suspense fallback={<div>Loading...</div>}>
                <BrowserRouter>
                    <Routes>
                        <Route element={<Layout logo={logo} />}>
                            <Route
                                path="/"
                                element={
                                    <AuthRoute>
                                        <Dashboard />
                                    </AuthRoute>
                                }
                            />

                            {/* profile */}

                            <Route
                                path="/profile"
                                element={
                                    <AuthRoute>
                                        <ViewEditProfile />
                                    </AuthRoute>
                                }
                            />

                            {/* applications */}

                            <Route
                                path="/applications"
                                element={
                                    <AuthRoute>
                                        <Applications />
                                    </AuthRoute>
                                }
                            />

                            <Route
                                path="/applications/add"
                                element={
                                    <AuthRoute>
                                        <AddApplication />
                                    </AuthRoute>
                                }
                            />

                            <Route
                                path="/applications/:id"
                                element={
                                    <AuthRoute>
                                        <EditApplication />
                                    </AuthRoute>
                                }
                            />

                            <Route
                                path="/applications/:applicationId/revisions/"
                                element={
                                    <AuthRoute>
                                        <Reviews />
                                    </AuthRoute>
                                }
                            />
                            {/* applications custom plans */}

                            <Route
                                path="/applications/:applicationId/custom-plans"
                                element={
                                    <AuthRoute>
                                        <CustomPlans />
                                    </AuthRoute>
                                }
                            />

                            <Route
                                path="/applications/:applicationId/custom-plans/add"
                                element={
                                    <AuthRoute>
                                        <AddCustomPlan />
                                    </AuthRoute>
                                }
                            />

                            <Route
                                path="/applications/:applicationId/custom-plans/:id"
                                element={
                                    <AuthRoute>
                                        <EditCustomPlan />
                                    </AuthRoute>
                                }
                            />
                            {/* themes */}

                            <Route
                                path="/themes"
                                element={
                                    <AuthRoute>
                                        <Themes />
                                    </AuthRoute>
                                }
                            />

                            <Route
                                path="/themes/add"
                                element={
                                    <AuthRoute>
                                        <AddTheme />
                                    </AuthRoute>
                                }
                            />

                            <Route
                                path="/themes/:id"
                                element={
                                    <AuthRoute>
                                        <EditTheme />
                                    </AuthRoute>
                                }
                            />
                            {/* subscriptions */}

                            <Route
                                path="/subscriptions"
                                element={
                                    <AuthRoute>
                                        <Subscriptions />
                                    </AuthRoute>
                                }
                            />

                            {/* DemoStores */}

                            <Route
                                path="/demoStores"
                                element={
                                    <AuthRoute>
                                        <DemoStores />
                                    </AuthRoute>
                                }
                            />

                            <Route
                                path="/demoStores/add"
                                element={
                                    <AuthRoute>
                                        <AddDemoStore />
                                    </AuthRoute>
                                }
                            />

                            <Route
                                path="/demoStores/:id"
                                element={
                                    <AuthRoute>
                                        <EditDemoStore />
                                    </AuthRoute>
                                }
                            />

                            {/* Employees */}

                            <Route
                                path="/employees"
                                element={
                                    <AuthRoute>
                                        <Employees />
                                    </AuthRoute>
                                }
                            />

                            <Route
                                path="/employees/add"
                                element={
                                    <AuthRoute>
                                        <AddEmployee />
                                    </AuthRoute>
                                }
                            />

                            <Route
                                path="/employees/:id"
                                element={
                                    <AuthRoute>
                                        <EditEmployee />
                                    </AuthRoute>
                                }
                            />
                            {/* Payments */}

                            <Route
                                path="/payments"
                                element={
                                    <AuthRoute>
                                        <Payments />
                                    </AuthRoute>
                                }
                            />

                            {/* Coupons */}

                            <Route
                                path="/coupons"
                                element={
                                    <AuthRoute>
                                        <Coupons />
                                    </AuthRoute>
                                }
                            />

                            <Route
                                path="/coupons/add"
                                element={
                                    <AuthRoute>
                                        <AddCoupon />
                                    </AuthRoute>
                                }
                            />

                            <Route
                                path="/coupons/:id"
                                element={
                                    <AuthRoute>
                                        <EditCoupon />
                                    </AuthRoute>
                                }
                            />
                            {/* settings */}
                            <Route
                                path="/settings"
                                element={
                                    <AuthRoute>
                                        <Settings />
                                    </AuthRoute>
                                }
                            />
                            {/* IdentityVerification */}

                            <Route
                                path="/settings/identityVerification"
                                element={
                                    <AuthRoute>
                                        <IdentityVerification />
                                    </AuthRoute>
                                }
                            />
                            <Route
                                path="/settings/taxNumber"
                                element={
                                    <AuthRoute>
                                        <TaxNumber />
                                    </AuthRoute>
                                }
                            />

                            {/* PaymentMethods */}

                            <Route
                                path="/settings/payment-methods"
                                element={
                                    <AuthRoute>
                                        <PaymentMethods />
                                    </AuthRoute>
                                }
                            />

                            <Route
                                path="/settings/payment-methods/add"
                                element={
                                    <AuthRoute>
                                        <AddPaymentMethod />
                                    </AuthRoute>
                                }
                            />

                            <Route
                                path="/settings/payment-methods/:id"
                                element={
                                    <AuthRoute>
                                        <EditPaymentMethod />
                                    </AuthRoute>
                                }
                            />
                            {/* webhooks */}

                            <Route
                                path="/webhooks"
                                element={
                                    <AuthRoute>
                                        <Webhooks />
                                    </AuthRoute>
                                }
                            />

                            <Route
                                path="/webhooks/:id"
                                element={
                                    <AuthRoute>
                                        <EditWebhook />
                                    </AuthRoute>
                                }
                            />

                            {/*  */}

                            <Route
                                path="*"
                                element={
                                    <AuthRoute>
                                        <NotFound />
                                    </AuthRoute>
                                }
                            />
                        </Route>

                        {/*Auth Routes */}
                        <Route
                            path="/logout"
                            element={
                                <AuthRoute>
                                    <Logout />
                                </AuthRoute>
                            }
                        />
                        <Route
                            path="/login"
                            element={
                                <GuestRoute>
                                    <Login logo={logo} />
                                </GuestRoute>
                            }
                        />
                        <Route
                            path="/register"
                            element={
                                <GuestRoute>
                                    <Register logo={logo} />
                                </GuestRoute>
                            }
                        />
                    </Routes>
                </BrowserRouter>
            </Suspense>
        );
    };

    if (!token) return RenderApp();
    if (isLoggedIn !== null) return RenderApp();
    return <Loader />;
};

export default App;
